"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrRoute = void 0;
const config_1 = __importDefault(require("next/config"));
const link_1 = __importDefault(require("next/link"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_lib_router_open_method_1 = require("@hotelplan/fdr.lib.router.open-method");
const fdr_lib_router_target_page_1 = require("@hotelplan/fdr.lib.router.target-page");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const { publicRuntimeConfig = {} } = (0, config_1.default)();
const { nextVersion = 12 } = publicRuntimeConfig;
const RawLink = styled_components_1.default.a(({ theme }) => theme.link.primary);
const NextLinkStyled = (0, styled_components_1.default)(link_1.default)(({ theme }) => theme.link.primary);
const FdrRoute = (_a) => {
    var _b;
    var { link, testId, linkAs: as, children, className, onMouseEnter, onClick, onFocus } = _a, routeProps = __rest(_a, ["link", "testId", "linkAs", "children", "className", "onMouseEnter", "onClick", "onFocus"]);
    const url = (link === null || link === void 0 ? void 0 : link.url) || '';
    const target = (0, fdr_lib_router_open_method_1.getFdrOpenMethod)(link === null || link === void 0 ? void 0 : link.openMethod);
    if (process.env.NODE_ENV === 'development') {
        url === '' &&
            // eslint-disable-next-line no-console
            console.warn(`You have not passed href property to RouterLink`);
        !nextVersion &&
            // eslint-disable-next-line no-console
            console.warn(`nextVersion is not defined in publicRuntimeConfig, which is required for FdrRoute`);
    }
    const linkProps = {
        href: url,
        target,
        'data-id': testId,
        className,
        onClick,
        onMouseEnter,
        onFocus,
    };
    if (!url)
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    // external links should simply render an anchor
    if ((link === null || link === void 0 ? void 0 : link.type) !== supergraph_api_1.FdrLinkType.Internal) {
        return react_1.default.createElement(RawLink, Object.assign({}, linkProps), children);
    }
    // locale needs to be defined and passed explicitly to next/link props
    const locale = (_b = (0, fdr_lib_router_target_page_1.getFdrTargetPageData)(url)) === null || _b === void 0 ? void 0 : _b.locale;
    // added since next 11 doesn't support legacyBehaviour
    if (nextVersion === 11 && /^(tel:|mailto:)/.test(url)) {
        return react_1.default.createElement(RawLink, Object.assign({}, linkProps), children);
    }
    return nextVersion >= 14 ? (react_1.default.createElement(NextLinkStyled, Object.assign({ locale: locale }, linkProps, routeProps), children)) : (react_1.default.createElement(link_1.default, Object.assign({ legacyBehavior: true, locale: locale, href: url, as: as }, routeProps),
        react_1.default.createElement(RawLink, Object.assign({}, linkProps), children)));
};
exports.FdrRoute = FdrRoute;
//# sourceMappingURL=fdr-route.js.map